import * as React from 'react';
/**
 * React context for used by useServices and withServiceProps or for your own access to a configured IServiceProvider.
 */
export var ServiceProviderContext = React.createContext(undefined);
//# sourceMappingURL=ServiceProviderContext.js.map